export default __webpack_public_path__ + "static/media/WelcomeA.6a8d0447.jpg";